import {
  createCollection,
  localOnlyCollectionOptions,
} from '@platform/db/tanstack-db';
import { FinanceHubCustomerRow } from '@finance-hub/domain/customers/blocs/types/customer-list';

/**
 * Local-only collection holding the Customers table rows, keyed by chat id.
 *
 * Both the initial 50-row response and the unbounded one write here, so the
 * table reads a single list instead of joining two query results.
 */
export const customerListCollection = createCollection(
  localOnlyCollectionOptions<FinanceHubCustomerRow>({
    getKey: (row) => row.chatId,
    id: 'finance-hub-customers',
  }),
);
